<div id="configurator">
  @if (showToolbar) {
    <div id="toolbar">
      <div class="section-header toolbar">
        <button
          mat-icon-button
          (click)="selectPart($event, makeFinishedGood())"
          [disabled]="!finished_good_selectable()"
          matTooltip="Finished Good"
        >
          <mat-icon class="material-symbols-outlined">manufacturing</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="selectPart($event, makeNettPrice())"
          [disabled]="!nett_price_selectable()"
          matTooltip="Nett Price"
        >
          <mat-icon class="material-symbols-outlined">payments</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="!can_paste()"
          matTooltip="Paste"
          (click)="onPaste()"
        >
          <mat-icon>content_paste</mat-icon>
        </button>
      </div>
    </div>
  }

  @for (agg of activeAggregates; track agg) {
    <div class="aggregate-section">
      <h4 class="section-header">{{ agg.type }}</h4>
      <div class="configurator-aggregate">
        <mat-slide-toggle
          [disabled]="!agg.isActive"
          [checked]="true"
          (change)="toggleAggEdit($event)"
        >
          <strong>
            <em>Editting:</em>
            <em>{{ getAggregateDescription(agg.internal_id) }}</em>
          </strong>
        </mat-slide-toggle>
      </div>
    </div>
  }

  @if (showPartSelector) {
    <div id="part-configuration">
      <div class="section-header section-header-with-action">
        <h4 style="margin: 0">Part Selector</h4>
        <button mat-icon-button type="button" (click)="clearall()">
          <mat-icon>cleaning_services</mat-icon>
        </button>
      </div>
      <div id="search-console">
        <form>
          <div class="input-container console-row">
            <div class="console-row-item search-input">
              <input
                type="text"
                [(ngModel)]="searchQuery"
                name="search_query"
                (keyup.enter)="search()"
              />
            </div>
            <div>
              <button type="button" (click)="search()">Search</button>
            </div>
          </div>
          <div id="facets" class="console-row">
            <div id="group" class="console-row-item">
              <select
                [(ngModel)]="filterGroup"
                (change)="filterByGroup()"
                name="part_group"
              >
                <option value="" selected="selected">Select Group ...</option>
                @for (p of partGroups().sort(); track p) {
                  <option value="{{ p }}">{{ p }}</option>
                }
              </select>
            </div>
            <div id="manufacturer" class="console-row-item">
              <select
                [(ngModel)]="filterManufacturer"
                (change)="filterByManufacturer()"
                name="part_manufacturer"
              >
                <option value="" selected="selected">Manufacturer</option>
                @for (p of partManufacturers().sort(); track p) {
                  <option value="{{ p }}">{{ p }}</option>
                }
              </select>
            </div>
          </div>
          @if (showPartFilter) {
            <div id="filter-row" class="console-row">
              <div id="filters">
                <div class="search-filter">
                  <span id="all" selected class="filter-text">All</span>
                </div>
                <div class="search-filter">
                  <span id="parts" class="filter-text">Parts</span>
                </div>
                <div class="search-filter">
                  <span id="enclosures" class="filter-text">Enclosures</span>
                </div>
                <div class="search-filter">
                  <span id="composites" class="filter-text">Composites</span>
                </div>
              </div>
            </div>
          }
        </form>
      </div>
      @if (!fetching()) {
        <cdk-virtual-scroll-viewport
          itemSize="100"
          minBufferPx="500"
          maxBufferPx="900"
          id="part-selector"
        >
          <div class="part" *cdkVirtualFor="let part of viewportParts()">
            <div class="header">
              <span class="action" title="Add Part">
                <button
                  (click)="selectPart($event, part)"
                  class="add"
                  [disabled]="isPartDisabled(part)"
                >
                  +
                </button>
              </span>
              <h5 class="part-ref">
                @if (part.part_is_enclosure) {
                  <span>[E]&nbsp;</span>
                }
                @if (part.type == "composite") {
                  <span>[C]&nbsp;</span>
                }
                {{ part.ref }}
              </h5>
              <div class="markup-selection" title="Markup">
                @for (markup of part.markups; track markup) {
                  <span
                    class="markup-box"
                    [ngClass]="
                      part.selectedMarkup == 1 + markup / 100 ? 'active' : ''
                    "
                    (click)="updateSelectedMarkup(part, markup)"
                  >
                    {{ markup }}
                  </span>
                }
              </div>
            </div>
            <span class="description">{{ part.description }}</span>
          </div>
        </cdk-virtual-scroll-viewport>
      }
      @if (fetching()) {
        <div class="part">
          <mat-spinner></mat-spinner>
          <p>Fetching data...</p>
        </div>
      }
    </div>
  }
</div>
